module.exports = __webpack_public_path__ + "4279811fc52151d89e6a41d8b7540a86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/knowin_white.png
// module id = 319
// module chunks = 1